import { render, staticRenderFns } from "./VatSettingsForm.vue?vue&type=template&id=6c345d1a&"
import script from "./VatSettingsForm.vue?vue&type=script&lang=js&"
export * from "./VatSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports